import { Link } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { useState } from "react";

import Logo from "../assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="w-full h-30 py-3 navber text-white shadow-md z-50 ">
      <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between">

        {/* Logo Section */}
        <Link to="/" className="flex items-center space-x-3">
          {/* Example logo icon (can replace with SVG or Image) */}
          <div className="w-45 items-center justify-center select-none">
            <img width="180" className="rounded-lg" src={Logo} alt="logo" />
          </div>
          {/* <span className="text-2xl font-bold tracking-wide whitespace-nowrap">
            Enginuity System
          </span> */}
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-6 font-semibold text-lg">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <Link to="/service" className="hover:underline">
            Service
          </Link>
          <Link to="/training" className="hover:underline">
            Training
          </Link>
          {/* <Link to="/courses" className="hover:underline">
            Courses
          </Link> */}
          {/* <Link to="/Team" className="hover:underline">
            Our Team
          </Link> */}
          <Link to="/contact" className="hover:underline">
            Contact
          </Link>
        </div>

        {/* Mobile Icon */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu">
            {isOpen ? <HiOutlineX size={28} /> : <HiOutlineMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden navber backdrop-blur-md px-4 pb-4 space-y-2 text-lg bg-gray-900">
          <Link
            to="/"
            onClick={() => setIsOpen(false)}
            className="block hover:underline"
          >
            Home
          </Link>
          <Link
            to="/training"
            onClick={() => setIsOpen(false)}
            className="block hover:underline"
          >
            Training
          </Link>
          <Link
            to="/service"
            onClick={() => setIsOpen(false)}
            className="block hover:underline"
          >
            Service
          </Link>
          <Link
            to="/courses"
            onClick={() => setIsOpen(false)}
            className="block hover:underline"
          >
            Courses
          </Link>
          <Link
            to="/contact"
            onClick={() => setIsOpen(false)}
            className="block hover:underline"
          >
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
